import React, {useEffect, useRef} from 'react';
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

import {Player} from "video-react";
import store from "../../store";
import {setSquareFootageGroup} from "../../actions/sqftFunctions";
import {SQFT_GROUP} from "./constants";

const SquareFootageToolCabinetsIntro = (props) => {
  const {history, match} = props;
  const videoPlayerRef = useRef(null);
  const step = match.params ? +match.params.step : 1;
  const videoPath = "https://quotecountertops.com/video/sqft/";
  // const videoPath = "https://intro-videos.s3.amazonaws.com";

  const videos = {
    1: videoPath + "1.webm",
    2: videoPath + "2.webm",
    3: videoPath + "3.webm",
    4: videoPath + "4.webm",
    5: videoPath + "5.webm",
    6: videoPath + "6.webm"
  }

  useEffect(() => {
    if (!step || step > 6) {
      history.push("/sqft-cabinets-intro/1");
    }
    if (videoPlayerRef) {
      videoPlayerRef.current.play();
      videoPlayerRef.current.video.play();
      setTimeout(() => {
        videoPlayerRef.current.play(); // in case first time is not auto launched
        videoPlayerRef.current.video.play();

      }, 500)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoPlayerRef, step]);


  const handleNextClick = () => {
    if (+props.match.params.step === 6) {
      history.push("sqft/cabinets=1");
      store.dispatch(setSquareFootageGroup(SQFT_GROUP.cabinets));
    } else {
      history.push("/sqft-cabinets-intro/" + (+props.match.params.step + 1));
    }
  }

  return (
    <div className="in-video sqft-video">
      <div className="in-video-popup">
        <Player
          ref={videoPlayerRef}
          playsInline
          fluid={props.windowWidth < 991}
          autoPlay
          muted
          src={videos[step]}
        />
        <button className={props.windowWidth < 991
          ? "ui-button2 ui-button2--green in-video-button"
          : "ui-button3 ui-button3--green in-video-button"}
                onClick={handleNextClick}>
          <FormattedMessage id={step === 6 ? "introVideo.buttons.start" : "introVideo.buttons.next"}/>
        </button>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    visualizersLoaded: store.serverState.visualizersLoaded
  };
};

const mapDispatchToProps = {
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(SquareFootageToolCabinetsIntro)
  )
);
